/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";

export interface DataTablesState extends Record<string, any> {}

const initialState: DataTablesState = {};

export const dataTablesSlice = createSlice({
    name: "dataTables",
    initialState,
    reducers: {
        addDataTable: (state, action: PayloadAction<DataTablesState>) => {
            state[Object.keys(action.payload)[0]] = action.payload[Object.keys(action.payload)[0]];
        },
        removeDataTable: (state, action: PayloadAction<string>) => {
            delete state[action.payload];
        },
    },
});

export const { addDataTable, removeDataTable } = dataTablesSlice.actions;

export const selectDataTableState = (state: RootState, tableName: string) => state.dataTables[tableName];

export default dataTablesSlice.reducer;
